export class RevenuePostAdjustmentQuery {
    public constructor(init?: Partial<RevenuePostAdjustmentQuery>) {
      Object.assign(this, init);
    }
      invoiceNumber: string;
      lotNumber: string;
   }